import destructiveIcon from 'assets/icons/icon-checkmark-fail-12.svg';
import sparksIcon from 'assets/icons/icon-sparks-12.svg';
import sparksLightIcon from 'assets/icons/icon-sparks-12-white.svg';
import React from 'react';
import { Button } from 'shared/components';

interface Props {
  label: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  btnSelector?: string;
  style?: 'primary' | 'secondary' | 'outline' | 'destructive__outline';
  icon?: 'sparks' | 'destructive';
  size?: 'sml' | 'med' | 'lrg';
  className?: string;
}

function getIconSource(
  style: NonNullable<Props['style']>,
  icon: NonNullable<Props['icon']>,
) {
  if (icon === 'destructive') {
    return destructiveIcon;
  }

  if (style === 'primary') {
    return sparksLightIcon;
  }

  return sparksIcon;
}

export const ProposalAIPrimaryButton: React.FC<Props> = ({
  label,
  onClick,
  disabled,
  btnSelector,
  style = 'primary',
  icon = 'sparks',
  size = 'lrg',
  className,
}) => {
  const iconSource = getIconSource(style, icon);

  return (
    <Button
      style={style}
      size={size}
      className={`proposal-ai-generator__primary-btn ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      btnSelector={btnSelector}
    >
      <img
        src={iconSource}
        alt=""
        aria-hidden="true"
        className="btn__icon btn__icon__left"
      />
      <span>{label}</span>
    </Button>
  );
};
